import * as yup from "yup";

export const schema = [
  yup.object({
    contact_list: yup
      .array()
      .of(
        yup.object().shape({
          value: yup.string().required("Contact value is required"),
        })
      )
      .min(1, "Please select at least one contact")
      .required("Please select the contact"),

    description: yup
      .string()
      .max(250, "Description must be at most 250 characters"),
      agency_id: yup
      .mixed()
      .test("valid-agency", "Please select an agency", (value) => {
        console.log("Agency validation - value:", value, "type:", typeof value);
        
        // Check if value is empty string (default "Select Agency" option)
        if (value === "" || value === null || value === undefined) {
          return false;
        }
        
        // Handle numeric values (agency ID as number)
        if (typeof value === "number") {
          return value > 0;
        }
        
        // Handle string values (agency ID)
        if (typeof value === "string") {
          return value !== "" && value !== "0";
        }
        
        // Handle object values (if agency comes as object)
        if (typeof value === "object" && value !== null) {
          const agencyId = value.id || value.value || value.agency_id;
          return agencyId && agencyId !== "" && agencyId !== "0";
        }
        
        return false;
      })
      .required("Please select an agency"),
    region: yup
      .mixed()
      // .test("valid-region", "Region is required", (value) => {
      //   // Adjust based on whether it's an object or string
      //   if (typeof value === "string") {
      //     return value && value !== "";
      //   } else if (typeof value === "object" && value !== null && value.length) {
      //     return value[0].region_id && value[0].region_id !== ""; // Example if region is an object
      //   }
      //   return false;
      // })
      // .nullable()
      .required("Please select a region"),
      total_quantity: yup
      .number()
      .typeError("Total quantity must be a number")
      .integer("Total quantity must be a whole number")
      .min(0, "Total quantity must be a positive number")
      .required("Total quantity is required")
      .test(
        "total-greater-than-damaged",
        "Total quantity must be greater than or equal to damaged quantity",
        function (value) {
          const { damaged_quantity } = this.parent;
          if (damaged_quantity && value) {
            return value >= damaged_quantity;
          }
          return true;
        }
      ),

    damaged_quantity: yup
      .number()
      .typeError("Damaged quantity must be a number")
      .integer("Damaged quantity must be a whole number")
      .min(0, "Damaged quantity must be a positive number")
      .required("Damaged quantity is required")
      .test(
        "damaged-less-than-total",
        "Damaged quantity cannot be greater than total quantity",
        function (value) {
          const { total_quantity } = this.parent;
          if (total_quantity && value) {
            return value <= total_quantity;
          }
          return true;
        }
      ),

    // agency_id: yup
    //   .mixed()
    //   .test("valid-agency", "Please select an agency", (value) => {
    //     // Handle both string and object cases
    //     if (typeof value === "string") {
    //       return value && value !== "";
    //     } else if (typeof value === "object" && value !== null) {
    //       // If it's an object, check if it has a valid id property
    //       return value.id || value.value || value.agency_id;
    //     }
    //     return false;
    //   })
    //   .required("Agency is required"),

    facility_id: yup
      .mixed()
      .test("valid-facility", "Please select a facility", (value) => {
        // Handle both string and object cases
        if (typeof value === "string") {
          return value && value !== "";
        } else if (typeof value === "object" && value !== null) {
          // If it's an object, check if it has a valid id property
          return value.id || value.value || value.facility_id;
        }
        return false;
      })
      .required("Facility is required"),
  }),
  
];


export const resourceFormConfig = [
  {
    id: 0,
    name: "General Information",
    fields: [
      {
        name: "rsrc_activity_id",
        label: "resourceformlabels.activity",
        type: "select",
        options: [],
      },
      {
        name: "rsrc_cat_id",
        label: "resourceformlabels.resourcecategory",
        type: "select",
        options: [],
      },

      {
        name: "name",
        label: "resourceformlabels.name",
        type: "select",
      },

      {
        name: "total_quantity",
        label: "resourceformlabels.totalquantity",
        type: "input",
        mandatory: "true",
      },
      {
        name: "damaged_quantity",
        label: "resourceformlabels.outofservice",
        type: "input",
        mandatory: "true",
      },
      {
        name: "deploy_quantity",
        label: "resourceformlabels.deployedquantity",
        type: "input",
        // mandatory: "true",
        disabled: true
      },
      {
        name: "available_quantity",
        label: "resourceformlabels.availablequantity",
        type: "input",
        // mandatory: "true",
        disabled: true
      },
      {
        name: "region",
        label: "resourceformlabels.region",
        type: "multi_select",
        mandatory: "true",
        is_multi: false,
      },
      {
        name: "agency_id",
        label: "resourceformlabels.agency",
        type: "select",
        mandatory: "true",
      },
      {
        name: "facility_id",
        label: "resourceformlabels.facility",
        type: "multi_select",
        is_multi: false,
        mandatory: "true",
        // options: [],
      },
      {
        name: "contact_list",
        label: "resourceformlabels.contact",
        type: "multi_select",
        mandatory: "true",
      },
      {
        name: "description",
        label: "resourceformlabels.description",
        type: "text_area",
      }
    ],
  },
];
